import type { PlayerTrailItem } from '../../../team/player/utils/teamPlayerTrail'
import type { OperationsNode } from '../types/operations.types'
import { entityHref, nodeHref } from './entityHref'

interface OperationsPlayerTrailArgs {
  /** The competition's owning org, once the tree has loaded. */
  organization: { id: string; name: string } | null
  /** Root-first path to the selected team, excluding the team itself. */
  ancestors: OperationsNode[]
  team: OperationsNode
}

/**
 * The breadcrumb for a roster player's screens opened from Operations — the
 * team's place in the hierarchy: `Org › Competition › Conference › Division ›
 * Team`. The org and the competition (the season at the root) link to their
 * pages; a conference, division or team only names where the user is.
 */
export const operationsPlayerTrail = ({
  organization,
  ancestors,
  team,
}: OperationsPlayerTrailArgs): PlayerTrailItem[] => {
  const trail: PlayerTrailItem[] = []
  if (organization) {
    trail.push({
      label: organization.name,
      to: entityHref('organization', organization.id),
    })
  }
  for (const node of ancestors) {
    trail.push(
      node.type === 'season'
        ? { label: node.name, to: nodeHref(node) }
        : { label: node.name }
    )
  }
  trail.push({ label: team.name })
  return trail
}
